import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import styled from "styled-components"

export const Grid = styled(Box)`
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 1rem;
  margin-bottom: 3rem;

  @media screen and (min-width: ${breakpoints.small}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: ${breakpoints.medium}) {
    grid-column-gap: 1.5rem;
    grid-row-gap: 1.5rem;
    margin-bottom: 4rem;
  }

  @media screen and (min-width: ${breakpoints.xlarge}) {
    margin-bottom: 6rem;
  }
`
